import { Injectable } from '@angular/core';
import { environment } from 'environments/environment';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { SearchHttpParams, SearchResult, sort } from '@heda/core-util';
import { MessageEventQueryParams } from 'app/integration/message-log/services/message-event';
import { MessageEvent } from 'app/integration/message-log/services/message-event';


@Injectable()
export class MessageEventService {
  protected baseUrl = `${environment.estnhsApi}/integration`;

  constructor(private http: HttpClient) {}

  public getLatestMessageEvent(resource: string, procedureId: number, eventType: string = null): Observable<MessageEvent | undefined> {
    const params: MessageEventQueryParams = {
      resource: resource,
      resourceId: String(procedureId),
      eventType: eventType
    };
    return this.search(params).pipe(
      map((response) => {
        return response?.data ? sort(response?.data, 'time', false)?.[0] : undefined;
      })
    );
  }

  private search(params: MessageEventQueryParams): Observable<SearchResult<MessageEvent>> {
    const p: any = Object.assign({}, params);
    return this.http
      .get(`${this.baseUrl}/message-events`, { params: SearchHttpParams.build(p) }) as Observable<SearchResult<MessageEvent>>;
  }

}
